import React, { useEffect, useRef } from "react";
import {
  clearAuthObj,
  handleLoginSession,
  login,
} from "../../features/auth/authSlice";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Form, Input, Select, Spin } from "antd";
import { clearFetchObj } from "../../features/fetch/fetchSlice";
import toast from "react-hot-toast";
import { clearGlobalObj } from "../../features/global/globalSlice";
import svg2 from "../../assets/svg/svg2.svg";
import svg3 from "../../assets/svg/svg3.svg";
import logo from "../../assets/img/nakuru-logo.png"; 
import { wspTypeData } from "../../data";
import { clearObj } from "../../features/obj/objSlice";

function Login() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { authLoading } = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(login(data));  
    if (res?.payload?.success) {
      await localStorage.setItem("token", res?.payload?.data?.result?.token);
      await toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await dispatch(handleLoginSession());
      await navigate("/dashboard");
    } else {
      toast.error(res?.payload?.messages?.message?? "Request failed");
    }
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  useEffect(() => {
    dispatch(clearAuthObj());
    dispatch(clearFetchObj());
    dispatch(clearGlobalObj());
    dispatch(clearObj())
    localStorage.clear();
  }, []);
  return (
    <div className="login-pic w-full flex min-h-screen flex-col">
      <div className="flex items-center justify-center  min-h-screen">
        <div className="login-frame lg:w-[76.3125rem] w-full h-[47.5rem] p-[.75rem] flex ">
          <div className="bg-[#F4F3F3] rounded-[1.25rem] lg:w-[45.5rem]  w-full h-full lg:px-[6.25rem] px-3 lg:py-[2.5rem]">
            <div className="flex items-center justify-center flex-col gap-y-[.62rem]">
               <img src={logo} alt="logo" className="h-[6.75rem] w-[9.1875rem] object-contain"/> 
              <span className="typography_1 appleAlt">Sign In</span>
              <span className="typography_2 appleAlt">
                Continue to Platform
              </span>
            </div>

            <Form
              layout="vertical"
              ref={formRef}
              name="control-ref"
              onFinish={onFinish}
              className="mt-[2.5rem] w-full"
              style={{
                maxWidth: "100%",
              }}
              form={form}
            >
              {/* <Form.Item
                name="damAgencyId"
                className=""
                label={"Select User"}
                rules={[
                  {
                    required: true,
                    message: "Please select user",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    wspTypeData?.length > 0 &&
                    wspTypeData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item> */}

              <Form.Item
                label="Email address"
                className="login-form-item"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password",
                  },
                ]}
              >
                <Input.Password placeholder="password" className="input" />
              </Form.Item>

              <div className="flex justify-center w-full my-[2.5rem]">
                <button
                  className="cstm-btn-2"
                  type="submit"
                  disabled={authLoading ? true : false}
                >
                  {authLoading ? <Spin /> : "Sign In"}
                </button>
              </div>

              <div className="flex justify-between ">
                <Checkbox
                  className="typography_2 appleAlt flex items-center"
                  onChange={onChange}
                >
                  Remember Me
                </Checkbox>
                <Link
                  // onClick={() => navigate("/forgot-email")}
                  className="typography_2  appleAlt flex items-center gap-x-[1rem]"
                >
                  <img src={svg2} alt="svg2" /> Forgot Password?
                </Link>
              </div>
            </Form>
          </div>
          <div className="px-[4rem] py-[2.38rem] lg:w-[30.8125rem] w-full lg:flex hidden flex-col h-full">
            {/* <div className="bg-white rounded-[.75rem] p-[.75rem] w-[12.5rem]"> */}
              {/* <img src={logo} alt="logo" className="h-[5vh] object-contain"/> */}
            {/* </div> */}

            <div className="mt-[4rem] text-[0.875rem] font-[400] text-white font-appleAlt">
              Welcome
            </div>
            <div className="my-[.94rem] font-appleAlt font-[700] text-[2rem] text-white">
              WATER REGULATION INFORMATION SYSTEM (WARIS)
            </div>
            <div className=" font-appleAlt font-[500] text-[1.125rem] text-white">
             NAWASCCO Software application designed for database management, aiding in
              the input, consolidation, and analysis of data from Water
              Utilities to produce performance reports for the water sector.
            </div>

            <div className="mt-auto bottom-0 text-[1.125rem] font-[500] font-appleAlt flex items-center text-white ">
              Powered By Smart People Africa
              <span className="ml-auto">
                <img src={svg3} alt="svg3" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
